<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { p1Api } from '@/lib/p1-api';
const route = useRoute();
const router = useRouter();
const message = ref('正在验证企业微信身份…');
onMounted(async () => {
  const code = typeof route.query.code === 'string' ? route.query.code : '';
  const state = typeof route.query.state === 'string' ? route.query.state : '';
  try {
    const session = await p1Api.wecomCallback(code, state);
    sessionStorage.setItem('hsl-ems-csrf', session.csrfToken);
    await router.replace('/documents');
  } catch {
    message.value = '无法自动绑定或登录，请使用账号密码登录并联系管理员。';
  }
});
</script>
<template>
  <main class="auth-layout">
    <section class="auth-panel">
      <p class="phase">企业微信身份</p>
      <h1>{{ message }}</h1>
      <RouterLink class="primary-link" to="/login">返回登录</RouterLink>
    </section>
  </main>
</template>
